import { Hearing } from '@enview/interface/types/bills/Bill';
import React, { useMemo, useState } from 'react';
import { convertIdToAbbreviatedTitle } from '../../../helpers/BillHelper';
import RelatedBillPill from './RelatedBillPill';
import './Hearings.scss';
import { BillAPI } from '../../../api';
import ArrowDown from '../../../components/svg/ArrowDown';
import { useSelector } from 'react-redux';
import { State } from '../../../dux/@types';
interface HearingRelatedBillsProps {
  hearing: Hearing;
}

export const HearingRelatedBills: React.FC<HearingRelatedBillsProps> = ({
  hearing,
}) => {
  const relatedBills =
    hearing.relatedBills?.map((bill) => {
      const abbrTitle = convertIdToAbbreviatedTitle(bill.id);
      return {
        id: bill.id,
        abbrTitle,
      };
    }) ?? [];

  const { teamMemberships } = useSelector(
    (state: State) => state.account.organizationUser,
  )!;
  const teamIds = teamMemberships.map((team) => team.teamId);
  const { data: trackedBills } =
    BillAPI.endpoints.getTrackedBillsLimit.useQuery(teamIds);

  const trackedBillIds = useMemo(
    () => new Set(trackedBills?.bills ?? []),
    [trackedBills],
  );

  const [expanded, setExpanded] = useState(false);

  const collator = React.useMemo(
    () =>
      new Intl.Collator('en', {
        numeric: true,
        sensitivity: 'base',
        ignorePunctuation: true,
      }),
    [],
  );

  const sortedBills = React.useMemo(
    () => [...relatedBills].sort((a, b) => collator.compare(a.abbrTitle, b.abbrTitle)),
    [relatedBills, collator],
  );

  const COLLAPSED_COUNT = 5;

  const visibleBills = expanded ? sortedBills : sortedBills.slice(0, COLLAPSED_COUNT);

  const remaining = Math.max(sortedBills.length - COLLAPSED_COUNT, 0);

  return (
    <div
      className={`hearings-bills ${
        expanded ? 'hearings-bills__expanded' : 'hearings-bills__collapsed'
      } ${!!remaining && !expanded ? 'hearings-bills__veil' : ''}`}
      onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
    >
      {visibleBills.map((relatedBill, index) => (
        <RelatedBillPill
          isTracked={trackedBillIds.has(relatedBill.id)}
          key={`related-bill-pill ${index}`}
          relatedBill={relatedBill}
        />
      ))}

      {!!remaining && (
        <div className="hearings-bills__toggle-wrap">
          <p
            aria-expanded={expanded}
            className="hearings-bills__toggle"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded((v) => !v);
            }}
          >
            {expanded ? 'show fewer' : 'show more'}
            <ArrowDown
              className={`inline-block ml-1 h-4 w-4 ${
                expanded ? 'hearings-bills__rotate' : ''
              }`}
            />
          </p>
        </div>
      )}
    </div>
  );
};

export default HearingRelatedBills;
